(() => {
  /**
   * 等待元素出现后执行回调
   * @param {string} selector
   * @param {(el:Element)=>void} cb
   * @param {{timeout?:number, once?:boolean}} [opts]
   */
  function onElementReady(selector, cb, opts = {}) {
    const { timeout = 20000, once = true } = opts;

    const found = document.querySelector(selector);
    if (found) {
      cb(found);
      return;
    }

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        if (once) observer.disconnect();
        cb(el);
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    if (timeout > 0) setTimeout(() => observer.disconnect(), timeout);
  }

  function injectStyleOnce(id, cssText) {
    if (document.getElementById(id)) return;
    const style = document.createElement('style');
    style.id = id;
    style.textContent = cssText;
    document.head.appendChild(style);
  }

  // 1) 注入样式
  injectStyleOnce('lp-badge-style', `
    .lp-badge {
      color: #888888;
    }
  `);

  // 2) 等待 lionloyalty app 的元素出现后，在它后面插入元素
  const APP_SELECTOR = '.fk-bottom-section .lion-available-rewards.lion-integrated-page-section .lion-integrated-page-section__heading-underline';

  onElementReady(APP_SELECTOR, (target) => {
    // 避免重复插入
    if (target.nextElementSibling?.dataset?.injected === 'after-app-badge') return;

    const div = document.createElement('div');
    div.className = 'lp-badge';
    div.dataset.injected = 'after-app-badge';
    div.textContent = 'For physical rewards, please add the item to your cart and apply the reward code at checkout';

    // 插在目标元素之后
    target.insertAdjacentElement('afterend', div);
  }, { timeout: 20000, once: true });
})();
